/* eslint-disable */
$(document).ready(function() {
  // JavaScript to be fired on single posts pages
  // alert('single');

   const meta = $('.entry-meta');
   const metaCopy = meta;
   const h2 = $('.entry-content h2').first()
   meta.detach()
   h2.after(metaCopy)
});



// WEBPACK FOOTER //
// ./scripts/pages/single.js